import { render, staticRenderFns } from "./claim_list_pc.vue?vue&type=template&id=3205fa3d&scoped=true&"
import script from "./claim_list_pc.vue?vue&type=script&lang=js&"
export * from "./claim_list_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205fa3d",
  null
  
)

export default component.exports